import React, { useState } from 'react'

import DetailedPrice from './DetailedPrice'
import s from './StickyFooter.module.scss'
import TotalPrice from './TotalPrice'

export default function StickyFooter() {
  const [detailedPriceOpened, setDetailedPriceOpened] = useState(false)
  const toggleDetailedPriceOpened = () => setDetailedPriceOpened(!detailedPriceOpened)

  return (
    <button className={s['sticky-footer']} onClick={toggleDetailedPriceOpened}>
      {detailedPriceOpened && <DetailedPrice />}
      <TotalPrice detailedPriceOpened={detailedPriceOpened} />
    </button>
  )
}
